import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'small' | 'medium' | 'large';
}

export default function ComicCard({ comic, size = 'medium' }: ComicCardProps) {
  const coverSizes = {
    small: 'w-[130px] sm:w-[150px]',
    medium: 'w-[160px] sm:w-[180px]',
    large: 'w-[180px] sm:w-[210px]',
  };

  const heightSizes = {
    small: 'h-[175px] sm:h-[200px]',
    medium: 'h-[215px] sm:h-[240px]',
    large: 'h-[240px] sm:h-[280px]',
  };

  return (
    <Link
      to={`/article/${comic.slug}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className={`${coverSizes[size]} ${heightSizes[size]} overflow-hidden rounded-lg mb-3`}>
        <img
          src={comic.cover}
          alt={comic.title}
          title={`${comic.title} - 韩漫在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className={coverSizes[size]}>
        <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1 mb-1">
          {comic.title}
        </h3>
        <div className="flex items-center justify-between">
          <span className="text-xs text-foreground-500">{comic.author}</span>
          <span className="flex items-center gap-0.5 text-xs text-accent-600">
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-star-fill text-[10px]"></i>
            </span>
            {comic.rating}
          </span>
        </div>
      </div>
    </Link>
  );
}